import { mutator } from 'satcheljs';
import { processOutlookSpaceAssetSyncResult } from '../privateActions';
import getStore from '../store';
import markAssetsByKeyAsDeleted from './assets/markAssetsByKeyAsDeleted';
import updateAssetChildren from './assets/updateAssetChildren';
import updateRenderingOrder from './projects/updateRenderingOrder';
import upsertAssets from './assets/upsertAssets';

mutator(processOutlookSpaceAssetSyncResult, ({ projectId, syncResult }) => {
    const project = getStore().projects.get(projectId);
    if (project) {
        project.skipToken = syncResult.skipToken || '';
        project.deltaToken = syncResult.deltaToken || '';

        upsertAssets(project.assets, syncResult.value, false);
        markAssetsByKeyAsDeleted(project.assets, syncResult.deleted);
        updateAssetChildren(project.assets);
        updateRenderingOrder(project);
    }
});
